import { FC, useRef } from 'react';
import { RenderPosition } from '../../../../enums/RenderPosition';
import { MinMaxFilter } from '../../../../types/FilterTypes';
import { DropdownOption } from '../../../style';
import MinMaxDropdownOption from '../../filters/min-max-dropdown-option/MinMaxDropdownOption';

type RangeDropdownOptionProps = {
  possibleRange: MinMaxFilter<number>;
  type: 'am-label' | 'am-dropdown';
  value: MinMaxFilter<number>;
  maxLength?: number;
  inputType?: string;
  filterHeight: number;
  handleValueChange: (val: MinMaxFilter<number>) => void;
  handleEnterKeyChange: () => void;
  renderPosition: RenderPosition;
  left?: number;
};

const RangeDropdownOption: FC<RangeDropdownOptionProps> = ({
  possibleRange,
  type,
  value,
  maxLength,
  inputType,
  filterHeight,
  handleValueChange,
  handleEnterKeyChange,
  renderPosition,
  left = 0,
}) => {
  const rangeDropdownOptionRef = useRef<HTMLElement>(null);

  return (
    <DropdownOption
      className={type === 'am-label' ? 'react-table-header-range unflex' : 'range-dropdown-option'}
      filterHeight={filterHeight}
      dynamicRender
      left={left}
      renderPosition={renderPosition}
      ref={rangeDropdownOptionRef as any}
    >
      <MinMaxDropdownOption
        min={value?.min}
        max={value?.max}
        minPossibleValue={possibleRange.min}
        maxPossibleValue={possibleRange.max}
        maxLength={maxLength}
        inputType={inputType}
        valueChangeAction={handleValueChange}
        enterKeyAction={handleEnterKeyChange}
      />
    </DropdownOption>
  );
};

export default RangeDropdownOption;
